const arrayNotEmpty = (i) => !!(i && i.length);

/**
*   Производит склонение строковой части, относящийся к числу, к именительному падежу
**/
const formatString = (value, type) => {
    let daysChoice = ['день', 'дня', 'дней'];
    let choiceIndex = 2;

    if (value < 10 || value > 15) {
        let rem = value % 10;
        if (rem === 1) choiceIndex = 0;
        else if (rem > 1 && rem < 5) choiceIndex = 1;
    }

    let stringPart;
    if (type === 'days') {
        stringPart = daysChoice[choiceIndex];
    } else if (type === 'rub') {
        stringPart = '₽';
    } else {
        throw Error('Not implemented type');
    }

    return `${value} ${stringPart}`;
};

/**
*   Производит склонение строковой части, относящийся к числу, к родительному падежу
**/
const formatIntervalString = (minValue, maxValue, type, intervalType) => {
    if (minValue === maxValue) {
        return formatString(minValue, type);
    }

    let daysChoice = ['дня', 'дней'];
    let [minChoiceIndex, maxChoiceIndex] = [1, 1];

    if (minValue < 10 || minValue > 15) {
        let remMin = minValue % 10;
        if (remMin === 1) minChoiceIndex = 0;
    }
    if (maxValue < 10 || maxValue > 15) {
        let remMax = maxValue % 10;
        if (remMax === 1) maxChoiceIndex = 0;
    }

    let minStringPart, maxStringPart;
    if (type === 'days') {
        minStringPart = daysChoice[minChoiceIndex];
        maxStringPart = daysChoice[maxChoiceIndex];
    } else if (type === 'rub') {
        minStringPart = maxStringPart = '₽';
    } else {
        throw Error('Not implemented type');
    }

    if (intervalType === 'min') {
        return `от ${minValue} ${minStringPart}`;
    } else if (intervalType === 'max') {
        return `до ${maxValue} ${maxStringPart}`;
    } else {
        return `${minValue}-${maxValue} ${maxStringPart}`;
    }
};

/**
 * Удаляет из массива arr значение value
 **/
const arrayRemove = (arr, value) => {
    return arr.filter(function(el) {
        return el != value;
    });
};

export {
    arrayNotEmpty,
    formatString,
    formatIntervalString,
    arrayRemove
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js